import {useTranslation} from "react-i18next";
import SvgSelector from "../../../../components/SvgSelector/SvgSelector";

const statusIcons = {
    "Filter": "cloacaStatusOn",
    "Review": "cloacaStatusReview",
    "Money": "cloacaStatusOff"
};

const StatusContent = ({ status }) => {
    const { t } = useTranslation();

    if (!statusIcons[status]) return null;

    return (
        <>
            <SvgSelector id={statusIcons[status]} />
            {t(status)}
        </>
    );
};

export default StatusContent;